export const GAME_MODES = {
  mini: {
    id: "mini",
    name: "Mini",
    boardSize: 11,
    tileCount: 60,
    rackSize: 5,
    multiplierDensity: "full",
    dynamicBoard: false,
    boardType: "MINI"
  },
  rapida: {
    id: "rapida",
    name: "Rápida",
    boardSize: 13,
    tileCount: 75,
    rackSize: 6,
    multiplierDensity: "full",
    dynamicBoard: false,
    boardType: "RÁPIDO"
  },
  clasica: {
    id: "clasica",
    name: "Clásica",
    boardSize: 15,
    tileCount: 100,
    rackSize: 7,
    multiplierDensity: "full",
    dynamicBoard: false,
    boardType: "VERBO"
  }
} as const;

export type GameModeKey = keyof typeof GAME_MODES;
